import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PwaUpdateComponent } from './shared/components/pwa-update/pwa-update.component';
import { PwaInstallComponent } from './shared/components/pwa-install/pwa-install.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, PwaUpdateComponent, PwaInstallComponent],
    standalone : true,
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Core KSA';
}
